<template>
  <span class="labels">
    <template v-for="item in filterItems" :key="item">
      <KkTag :label="String(item)" class="labels__item" />
    </template>
    <span v-show="isVisibleMoreTrigger" class="c-more__trigger"><strong @click="showAllItems">{{ $t('components.MoreItem.open', { count: items.length}) }}</strong></span>
    <span v-show="isVisibleCloseTrigger" class="c-more__trigger"><strong @click="shortItems">{{ $t('components.MoreItem.close') }}</strong></span>
  </span>
</template>

<script>
import { KkTag } from '../components/base'
export default {
  name: 'MoreItem',
  components: {
    KkTag
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    displayLength: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      isDisplayedAllItems: false
    }
  },
  computed: {
    isVisibleMoreTrigger() {
      return !this.isDisplayedAllItems && this.items.length > this.displayLength
    },
    isVisibleCloseTrigger() {
      return this.isDisplayedAllItems && this.items.length > this.displayLength
    },
    filterItems() {
      return this.isDisplayedAllItems ? this.items : this.items.slice(0, this.displayLength)
    },
  },
  created() {
    this.isDisplayedAllItems = this.items.length <= this.displayLength
  },
  methods: {
    showAllItems() {
      this.isDisplayedAllItems = true
    },
    shortItems() {
      this.isDisplayedAllItems = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';
.c-more__trigger {
  text-decoration-line: underline;
  strong {
    color: $color-font-base;
  }
}

.labels {
  display: flex;
  flex-wrap: wrap;
  &__item {
    margin-right: 5px;
    margin-bottom: 5px;
  }
}
</style>
